import { AxiosResponse } from 'axios';

import { ConfirmEmailProps, ResendConfirmationEmailProps } from 'models/form';
import { RegisterPayloadProps, ContactInfoCompanyProps, ContactInfoUserProps } from 'models/api';
import BaseApi from './BaseApi';

export class RegistrationApi extends BaseApi {
	constructor() {
		super('/registration');
	}

	register(body: RegisterPayloadProps): Promise<AxiosResponse<unknown>> {
		return this.httpClient.post({ body, conditions: { version: 'v2' } });
	}

	updateUser(
		body: ContactInfoCompanyProps | ContactInfoUserProps,
	): Promise<AxiosResponse<unknown>> {
		return this.httpClient.patch({ body, conditions: { version: 'v2', auth: true } });
	}

	resendConfirmationEmail(body: ResendConfirmationEmailProps): Promise<AxiosResponse<unknown>> {
		return this.httpClient.post({
			body,
			url: '/resend-confirmation-email',
			conditions: { version: 'v2' },
		});
	}

	confirmEmail(body: ConfirmEmailProps): Promise<AxiosResponse<unknown>> {
		return this.httpClient.post({ body, url: '/confirm', conditions: { version: 'v2' } });
	}
}

export const RegistrationService = new RegistrationApi();
